import Vue from 'vue'
import Router from 'vue-router'
import CsrfService from '@/common/csrf.service'

Vue.use(Router)

export const routes = [
  //****************************************************//
  //----------------- LANDING LAYOUT ------------------//
  //**************************************************//
  {
    path: '/login',
    components: {
      landing: () => import(/* webpackChunkName: "landing.chunk" */ '@/components/landingLayout/LandingLayout')
    },
    children: [{
      name: 'Login',
      path: '',
      component: () => import(/* webpackChunkName: "landing.chunk" */ '@/components/landingLayout/views/Login'),
      props: true,
      meta: {
        requiresAuth: false
      }
    }]
  },
  {
    path: '/register',
    components: {
      landing: () => import(/* webpackChunkName: "landing.chunk" */ '@/components/landingLayout/LandingLayout')
    },
    children: [{
      name: 'Register',
      path: '',
      component: () => import(/* webpackChunkName: "landing.chunk" */ '@/components/landingLayout/views/Register'),
      props: true,
      meta: {
        requiresAuth: false
      }
    }]
  },
  {
    path: '/phone-number-verification',
    components: {
      landing: () => import(/* webpackChunkName: "landing.chunk" */ '@/components/landingLayout/LandingLayout')
    },
    children: [{
      name: 'PhoneNumberVerification',
      path: '',
      component: () => import(/* webpackChunkName: "landing.chunk" */ '@/components/landingLayout/views/PhoneNumberVerification'),
      props: true,
      meta: {
        requiresAuth: false
      }
    }]
  },
  {
    path: '/reset',
    components: {
      landing: () => import(/* webpackChunkName: "landing.chunk" */ '@/components/landingLayout/LandingLayout')
    },
    children: [{
      name: 'Reset',
      path: '',
      component: () => import(/* webpackChunkName: "landing.chunk" */ '@/components/landingLayout/views/ForgetPassword'),
      props: true,
      meta: {
        requiresAuth: false
      }
    }]
  },
  {
    path: '/reset/confirm',
    components: {
      landing: () => import(/* webpackChunkName: "landing.chunk" */ '@/components/landingLayout/LandingLayout')
    },
    children: [{
      name: 'ResetConfirm',
      path: '',
      component: () => import(/* webpackChunkName: "landing.chunk" */ '@/components/landingLayout/views/ForgetPasswordConfirm'),
      props: true
    }]
  },
  {
    path: '/error',
    components: {
      landing: () => import(/* webpackChunkName: "landing.chunk" */ '@/components/landingLayout/LandingLayout')
    },
    children: [{
      name: 'ErrorPage',
      path: '',
      component: () => import(/* webpackChunkName: "landing.chunk" */ '@/components/landingLayout/views/ErrorPage'),
      props: true,
      meta: {
        requiresAuth: false
      }
    }]
  },
  {
    path: '/demo',
    components: {
      landing: () => import(/* webpackChunkName: "landing.chunk" */ '@/components/landingLayout/LandingLayout')
    },
    children: [{
      name: 'Demo',
      path: '',
      component: () => import(/* webpackChunkName: "landing.chunk" */ '@/components/landingLayout/views/Demo'),
      props: true,
      meta: {
        requiresAuth: false
      }
    }]
  },
  //***************************************************//
  //------------------ PREFERENCES -------------------//
  //*************************************************//
  {
    path: '/preferences',
    name: 'Preferences',
    components: {
      preferences: () => import(/* webpackChunkName: "app.chunk" */ '@/components/preferencesLayout/Preferences'),
    },
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  //****************************************************//
  //------------------- APP LAYOUT --------------------//
  //**************************************************//
  {
    path: '/',
    redirect: 'dashboard'
  },
  {
    path: '/dashboard',
    components: {
      app: () => import(/* webpackChunkName: "app.chunk", webpackPrefetch: true */ '@/components/appLayout/AppLayout')
    },
    children: [{
      path: '',
      name: 'Dashboard',
      component: () => import(
        /* webpackChunkName: "app.chunk", webpackPrefetch: true */ '@/components/appLayout/views/dashboard/Dashboard'
      ),
      meta: {
        requiresAuth: true
      }
    }]
  },
  //********************* PAYMENTS ******************//
  {
    path: '/payments',
    name: 'Payments',
    redirect: {
      name: 'Unpaid'
    },
    components: {
      app: () => import(/* webpackChunkName: "app.chunk", webpackPrefetch: true */ '@/components/appLayout/AppLayout')
    },
    children: [
      {
        path: '',
        name: 'UnpaidLayout',
        component: () => import(/* webpackChunkName: "app.chunk", webpackPrefetch: true */ '@/components/appLayout/views/payments/Payments'),
        meta: {
          requiresAuth: true
        },
        redirect: {
          name: 'Unpaid'
        },
        children: [
          //----- UNPAID -----//
          {
            path: 'unpaid',
            name: 'Unpaid',
            component: () => import(
              /* webpackChunkName: "app.chunk", webpackPrefetch: true */ '@/components/appLayout/views/payments/unpaid/Unpaid'
            ),
            props: true,
            meta: {
              requiresAuth: true
            }
          },
          //----- UNPAID ( ADD PAYMENT ALIMONY ) -----//
          {
            path: 'unpaid/alimony/:id?',
            name: 'AddPaymentSpousalMaintenance',
            component: () => import(
              /* webpackChunkName: "app.chunk", webpackPrefetch: true */ '@/components/appLayout/views/payments/unpaid/spousalMaintenance/AddPayment'
            ),
            props: true,
            meta: {
              requiresAuth: true
            }
          },
          //----- UNPAID ( ADD PAYMENT CHILD ) -----//
          {
            path: 'unpaid/child-support/:id?',
            name: 'AddPaymentChildMaintenance',
            component: () => import(
              /* webpackChunkName: "app.chunk", webpackPrefetch: true */ '@/components/appLayout/views/payments/unpaid/childMaintenance/AddPayment'
            ),
            props: true,
            meta: {
              requiresAuth: true
            }
          },
          //----- UNPAID ( ADD PAYMENT SHARED ) -----//
          {
            path: 'unpaid/shared-expenses/:id?',
            name: 'AddPaymentSharedExpenses',
            component: () => import(
              /* webpackChunkName: "app.chunk", webpackPrefetch: true */ '@/components/appLayout/views/payments/unpaid/sharedExpenses/AddPayment'
            ),
            props: true,
            meta: {
              requiresAuth: true
            }
          },
          //----- ONE-TIME EXPENSE ( ALIMONY ) -----//
          {
            path: 'unpaid/alimony/details/:id',
            name: 'ExpenseDetailsSpousalMaintenance',
            component: () => import(
              /* webpackChunkName: "app.chunk", webpackPrefetch: true */ '@/components/appLayout/views/payments/unpaid/spousalMaintenance/ExpenseDetails'
            ),
            props: true,
            meta: {
              requiresAuth: true
            }
          },
          //----- ONE-TIME EXPENSE ( CHILD ) -----//
          {
            path: 'unpaid/child-support/details/:id',
            name: 'ExpenseDetailsChildMaintenance',
            component: () => import(
              /* webpackChunkName: "app.chunk", webpackPrefetch: true */ '@/components/appLayout/views/payments/unpaid/childMaintenance/ExpenseDetails'
            ),
            props: true,
            meta: {
              requiresAuth: true
            }
          },
          //----- ONE-TIME EXPENSE ( SHARED ) -----//
          {
            path: 'unpaid/shared-expenses/details/:id',
            name: 'ExpenseDetailsSharedExpenses',
            component: () => import(
              /* webpackChunkName: "app.chunk", webpackPrefetch: true */ '@/components/appLayout/views/payments/unpaid/sharedExpenses/ExpenseDetails'
              ),
            props: true,
            meta: {
              requiresAuth: true
            }
          }
        ]
      },
      {
        path: '',
        name: 'RecurringLayout',
        component: () => import(/* webpackChunkName: "app.chunk", webpackPrefetch: true */ '@/components/appLayout/views/payments/Payments'),
        meta: {
          requiresAuth: true
        },
        children: [
          //----- RECURRING -----//
          {
            path: 'recurring',
            name: 'Recurring',
            component: () => import(
              /* webpackChunkName: "app.chunk", webpackPrefetch: true */ '@/components/appLayout/views/payments/recurring/Recurring'
            ),
            props: true,
            meta: {
              requiresAuth: true
            }
          },
          //----- RECURRING (ADD PAYMENT ALIMONY) -----//
          {
            path: 'recurring/alimony/:id?',
            name: 'ScheduleRecurringPaymentSpousalMaintenance',
            component: () => import(
              /* webpackChunkName: "app.chunk", webpackPrefetch: true */ '@/components/appLayout/views/payments/recurring/spousalMaintenance/ScheduleRecurringPayment'
            ),
            props: true,
            meta: {
              requiresAuth: true
            }
          },
          //----- RECURRING (ADD PAYMENT CHILD) -----//
          {
            path: 'recurring/child-support/:id?',
            name: 'ScheduleRecurringPaymentChildMaintenance',
            component: () => import(
                /* webpackChunkName: "app.chunk", webpackPrefetch: true */ '@/components/appLayout/views/payments/recurring/childMaintenance/ScheduleRecurringPayment'
            ),
            props: true,
            meta: {
              requiresAuth: true
            }
          },
          //----- RECURRING (ADD PAYMENT SHARED) -----//
          {
            path: 'recurring/shared-expenses/:id?',
            name: 'ScheduleRecurringPaymentSharedExpenses',
            component: () => import(
                /* webpackChunkName: "app.chunk", webpackPrefetch: true */ '@/components/appLayout/views/payments/recurring/sharedExpenses/ScheduleRecurringPayment'
            ),
            props: true,
            meta: {
              requiresAuth: true
            }
          },
          //----- RECURRING EXPENSE DETAILS ( ALIMONY ) -----//
          {
            path: 'recurring/alimony/details/:id',
            name: 'SpousalMaintenanceRecurringExpensesDetails',
            component: () => import(
              /* webpackChunkName: "app.chunk", webpackPrefetch: true */ '@/components/appLayout/views/payments/recurring/spousalMaintenance/RecurringExpensesDetails'
            ),
            props: true,
            meta: {
              requiresAuth: true
            }
          },
          //----- RECURRING EXPENSE DETAILS ( CHILD ) -----//
          {
            path: 'recurring/child-support/details/:id',
            name: 'ChildMaintenanceRecurringExpensesDetails',
            component: () => import(
              /* webpackChunkName: "app.chunk", webpackPrefetch: true */ '@/components/appLayout/views/payments/recurring/childMaintenance/RecurringExpensesDetails'
            ),
            props: true,
            meta: {
              requiresAuth: true
            }
          },
          //----- RECURRING EXPENSE DETAILS ( SHARED ) -----//
          {
            path: 'recurring/shared-expense/details/:id',
            name: 'SharedExpensesRecurringExpensesDetails',
            component: () => import(
              /* webpackChunkName: "app.chunk", webpackPrefetch: true */ '@/components/appLayout/views/payments/recurring/sharedExpenses/RecurringExpensesDetails'
            ),
            props: true,
            meta: {
              requiresAuth: true
            }
          }
        ]
      },
      {
        path: '',
        name: 'HistoryLayout',
        component: () => import(/* webpackChunkName: "app.chunk", webpackPrefetch: true */ '@/components/appLayout/views/payments/Payments'),
        children: [
          //----- HISTORY -----//
          {
            path: 'history',
            name: 'History',
            component: () => import(/* webpackChunkName: "app.chunk", webpackPrefetch: true */ '@/components/appLayout/views/payments/history/History'),
            props: true,
            meta: {
              requiresAuth: true
            }
          }
        ],
        meta: {
          requiresAuth: true
        }
      }
    ],
  },
  //********************* CALENDAR ******************//
  {
    path: '',
    components: {
      app: () => import(/* webpackChunkName: "app.chunk", webpackPrefetch: true */ '@/components/appLayout/AppLayout')
    },
    children: [{
      path: '/calendar',
      name: 'Calendar',
      component: () => import(
        /* webpackChunkName: "app.chunk", webpackPrefetch: true */ '@/components/appLayout/views/calendar/Calendar'
      ),
      props: true,
      meta: {
        requiresAuth: true
      }
    }]
  },
  {
    path: '',
    components: {
      app: () => import(/* webpackChunkName: "app.chunk", webpackPrefetch: true */ '@/components/appLayout/AppLayout')
    },
    children: [{
      path: '/calendar/add-event/:id?',
      name: 'AddEvent',
      component: () => import(
        /* webpackChunkName: "app.chunk", webpackPrefetch: true */ '@/components/appLayout/views/calendar/AddEvent'
      ),
      meta: {
        requiresAuth: true
      }
    }]
  },
  {
    path: '',
    components: {
      app: () => import(/* webpackChunkName: "app.chunk", webpackPrefetch: true */ '@/components/appLayout/AppLayout')
    },
    children: [{
      path: '/calendar/schedule-child-visitation',
      name: 'ScheduleChildVisitation',
      component: () => import(
        /* webpackChunkName: "app.chunk", webpackPrefetch: true */ '@/components/appLayout/views/calendar/ScheduleChildVisitation'
      ),
      meta: {
        requiresAuth: true
      }
    }]
  },
  //********************* MESSAGES CENTER ******************//
  {
    path: '/message-center',
    components: {
      app: () => import(/* webpackChunkName: "app.chunk", webpackPrefetch: true */ '@/components/appLayout/AppLayout')
    },
    children: [{
      path: '/message-center/:guid?',
      name: 'MessageCenter',
      component: () => import(
        /* webpackChunkName: "app.chunk", webpackPrefetch: true */ '@/components/appLayout/views/messageCenter/MessageCenter'
      ),
      props: true,
      meta: {
        requiresAuth: true
      }
    }]
  },
  //********************* REPORTS ******************//
  {
    path: '',
    components: {
      app: () => import(/* webpackChunkName: "app.chunk", webpackPrefetch: true */ '@/components/appLayout/AppLayout')
    },
    children: [{
      path: '/reports',
      name: 'Reports',
      component: () => import(
        /* webpackChunkName: "app.chunk", webpackPrefetch: true */ '@/components/appLayout/views/reports/Reports'
      ),
      meta: {
        requiresAuth: true
      }
    }]
  },
  //********************* CABINET ******************//
  {
    path: '',
    components: {
      app: () => import(/* webpackChunkName: "app.chunk", webpackPrefetch: true */ '@/components/appLayout/AppLayout')
    },
    children: [{
      path: '/document-storage',
      name: 'DocCabinet',
      component: () => import(
        /* webpackChunkName: "app.chunk", webpackPrefetch: true */ '@/components/appLayout/views/documentCabinet/DocCabinet'
      ),
      meta: {
        requiresAuth: true
      }
    }]
  },
  //********************* USER PROFILE ******************//
  {
    path: '/user-profile',
    components: {
      app: () => import(/* webpackChunkName: "app.chunk", webpackPrefetch: true */ '@/components/appLayout/AppLayout')
    },
    children: [{
      path: '',
      name: 'UserProfile',
      component: () => import(
        /* webpackChunkName: "app.chunk", webpackPrefetch: true */ '@/components/appLayout/views/profile/UserProfile'
      ),
      meta: {
        requiresAuth: true
      }
    }]
  },
  //********************* FAMILY   PROFILE ******************//
  {
    path: '/family-profile',
    components: {
      app: () => import(/* webpackChunkName: "app.chunk", webpackPrefetch: true */ '@/components/appLayout/AppLayout')
    },
    children: [{
      path: '',
      name: 'FamilyProfile',
      component: () => import(
          /* webpackChunkName: "app.chunk", webpackPrefetch: true */ '@/components/appLayout/views/profile/FamilyProfile'
          ),
      meta: {
        requiresAuth: true
      }
    }]
  },
  //********************* PAYMENTS METHODS ******************//
  {
    path: '/payment-methods',
    components: {
      app: () => import(/* webpackChunkName: "app.chunk", webpackPrefetch: true */ '@/components/appLayout/AppLayout')
    },
    children: [{
      path: '',
      name: 'PaymentMethods',
      component: () => import(
        /* webpackChunkName: "app.chunk", webpackPrefetch: true */ '@/components/appLayout/views/paymentMethods/PaymentMethods'
      ),
      meta: {
        requiresAuth: true
      }
    }]
  },
  {
    path: '*',
    redirect: '/dashboard'
  }
];

export const router = new Router({
  routes,
  mode: 'history',
  linkActiveClass: "active",
  linkExactActiveClass: "exact-active",
  // linkActiveClass: "exact-active",
  // linkExactActiveClass: "active"
});

export default router

import { API_ENV_NAME } from '@/common/config';

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const isAuthenticated = !!CsrfService.getToken();
  const paymentPreferenceCompleted = window.localStorage.getItem('paymentPreferenceCompleted') ? JSON.parse(window.localStorage.getItem('paymentPreferenceCompleted')) : null;
  const parentingSchedulePreferenceCompleted = window.localStorage.getItem('parentingSchedulePreferenceCompleted') ? JSON.parse(window.localStorage.getItem('parentingSchedulePreferenceCompleted')) : null;
  const coparentAdded = window.localStorage.getItem('coparentAdded') ? window.localStorage.getItem('coparentAdded') : null;
  const childAdded = window.localStorage.getItem('childAdded') ? JSON.parse(window.localStorage.getItem('childAdded')) : null;
  const subscriptionActivated = window.localStorage.getItem('subscriptionActivated') ? JSON.parse(window.localStorage.getItem('subscriptionActivated')) : null;
  const bankAccountAdded = window.localStorage.getItem('bankAccountAdded') ? JSON.parse(window.localStorage.getItem('bankAccountAdded')) : null;
  const isBankAccountSkipped = window.localStorage.getItem('isBankAccountSkipped') ? JSON.parse(window.localStorage.getItem('isBankAccountSkipped')) : false;
  
  if (API_ENV_NAME !== 'demo') {
    if (to.name === 'Demo') {
      next({
        path: '/login',
        query: {
          redirectTo: to.fullPath
        }
      })
    }
    if (from.name !== 'Login') {
      if (requiresAuth && !isAuthenticated) {
        next({
          path: '/login',
          query: {
            redirectTo: to.fullPath
          }
        })
      } else if (!requiresAuth && isAuthenticated && to.name === 'Login' && !to.query.mobile) {
        if (to.query.payment) {
          next('/payment-methods');
        } else if (!paymentPreferenceCompleted || !parentingSchedulePreferenceCompleted) {
          next('/preferences');
        } else {
          if (coparentAdded !== 'finished') {
            next('/family-profile')
          } else if (bankAccountAdded !== 'finished') {
            next('/payment-methods');
          } else {
            next('/dashboard');
          }
        }
      } else if (!requiresAuth && isAuthenticated && to.name === 'Login' && to.query.mobile) {
        next();
      } else if(to.name === 'FamilyProfile' || to.name === 'UserProfile') {
        next()
      } else if (requiresAuth && isAuthenticated && (!paymentPreferenceCompleted || !parentingSchedulePreferenceCompleted) && to.name !== 'Preferences') {
        next('/preferences')
      } else if (requiresAuth && isAuthenticated && paymentPreferenceCompleted && parentingSchedulePreferenceCompleted && to.name === 'Preferences') {
        if (coparentAdded !== 'finished') {
          next('/family-profile')
        } else if (bankAccountAdded !== 'finished') {
          next('/payment-methods');
        } else {
          next('/dashboard');
        }
      } else if (requiresAuth && isAuthenticated && paymentPreferenceCompleted && parentingSchedulePreferenceCompleted && (coparentAdded === 'unfinished' || coparentAdded === 'current' || childAdded === 'unfinished' || childAdded === 'current') && to.name !== 'FamilyProfile') {
        next('/family-profile')
      } else if (requiresAuth && isAuthenticated && paymentPreferenceCompleted && parentingSchedulePreferenceCompleted && coparentAdded === 'finished' && childAdded === 'finished' && (subscriptionActivated === 'unfinished' || subscriptionActivated === 'current' || (!isBankAccountSkipped && (bankAccountAdded === 'unfinished' || bankAccountAdded === 'current')))  && to.name !== 'PaymentMethods') {
        next('/payment-methods')
      }
      else {
        next()
      }
    } else {
      next();
    }
  } else {
    if (to.name !== 'Demo') {
      if ((requiresAuth && !isAuthenticated) || to.name === 'Login') {
        next({
          path: '/demo',
          query: {
            redirectTo: to.fullPath
          }
        })
      } else {
        next();
      }
    }
    next();
  }
});

router.afterEach(() => {
  document.body.scrollTop = document.documentElement.scrollTop = 0;
});
